import type {
  AccessRotateTarget,
  CreateJobResponse,
  JobUpdateRequest,
  JobWriteRequest,
  OkResponse,
  RegistrationAction,
} from '@crew/shared';
import type { User } from 'firebase/auth';
import { demoStore } from '@/demo/demoStore';
import { IS_DEMO } from '@/demo/demoMode';
import { apiRequest } from './api';

/** פעולות הניהול על עבודות. כל כתיבה עוברת דרך השרת (או מאגר התצוגה במצב demo). */
export interface JobsApi {
  create(body: JobWriteRequest): Promise<CreateJobResponse>;
  update(jobId: string, body: JobUpdateRequest): Promise<{ changed: string[] }>;
  remove(jobId: string): Promise<OkResponse>;
  setRegistration(jobId: string, action: RegistrationAction): Promise<OkResponse>;
  archive(jobId: string): Promise<OkResponse>;
  unarchive(jobId: string): Promise<OkResponse>;
  rotate(jobId: string, target: AccessRotateTarget): Promise<OkResponse>;
}

const enc = encodeURIComponent;

export function jobsApi(user: User): JobsApi {
  if (IS_DEMO) {
    return {
      create: (b) => demoStore.createJob(b),
      update: (id, b) => demoStore.updateJob(id, b),
      remove: (id) => demoStore.remove(id),
      setRegistration: (id, a) => demoStore.setRegistration(id, a),
      archive: (id) => demoStore.archive(id),
      unarchive: (id) => demoStore.unarchive(id),
      rotate: (id, t) => demoStore.rotate(id, t),
    };
  }
  return {
    create: (body) => apiRequest('/api/admin/jobs', { method: 'POST', body, user }),
    update: (id, body) => apiRequest(`/api/admin/jobs/${enc(id)}`, { method: 'PATCH', body, user }),
    remove: (id) => apiRequest(`/api/admin/jobs/${enc(id)}`, { method: 'DELETE', user }),
    setRegistration: (id, action) => apiRequest(`/api/admin/jobs/${enc(id)}/registration`, { method: 'POST', body: { action }, user }),
    archive: (id) => apiRequest(`/api/admin/jobs/${enc(id)}/archive`, { method: 'POST', user }),
    unarchive: (id) => apiRequest(`/api/admin/jobs/${enc(id)}/unarchive`, { method: 'POST', user }),
    rotate: (id, target) => apiRequest(`/api/admin/jobs/${enc(id)}/access/rotate`, { method: 'POST', body: { target }, user }),
  };
}
